import React, { useState } from 'react';
import { updateUser } from '../../services/UserServices';
import TextEditor from '../texteditor/TextEditor';
import ImageCropModal from '../scenarios/create/ImageCropModal';
import styles from './styles/AccountProfile.module.css';
import ProfileIcon from '../../images/profileicon.png';
import { transformIframes } from '../../utils/utils';
import ProfileStats from './ProfileStats';
import PinScenarioView from './PinScenarioView';
import FollowStats from './FollowStats';


const AccountProfile = ({ userIsAccountOwner, accountOwner, setAccountOwner }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [bio, setBio] = useState(accountOwner.bio);
    const [profilePicture, setProfilePicture] = useState(accountOwner.profilePicture);
    const [selectedFile, setSelectedFile] = useState(null);
    const [cropImageSrc, setCropImageSrc] = useState(null);

    const handleClickEditProfile = () => {
        setIsEditing(true);
    };

    const handleClickSaveChanges = async () => {
        try {
            const formData = new FormData();
            formData.append('bio', bio);
            if (selectedFile) {
                formData.append('image', selectedFile);
            }
            const data = await updateUser(accountOwner._id, formData);
            setAccountOwner((prevOwner) => ({
                ...prevOwner,
                bio,
                profilePicture: data.profilePicture || prevOwner.profilePicture,
            }));
            setIsEditing(false);
        } catch (error) {
            console.error('Error updating profile:', error);
        }
    };

    const handleClickCancel = () => {
        setIsEditing(false);
        setBio(accountOwner.bio);
        setProfilePicture(accountOwner.profilePicture);
    };

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            setCropImageSrc(URL.createObjectURL(file));
        }
    };

    const handleImageClick = () => {
        document.getElementById('fileInput').click();
    };

    // Separate handler for the main text editor
    const handleTextEditorChange = (data) => {
        setBio(data);
    };

    return (
        <div className={styles.profile}>
            {!isEditing ? (
                <>
                    <div className={styles.viewHeader}>
                        <div className={styles.profilePictureContainer}>
                            <img className={styles.profilePictureImage} src={profilePicture ? profilePicture : ProfileIcon} alt="Profile" />
                        </div>

                        <div className={styles.userInfo}>
                            <h3 className={styles.username}>{accountOwner.username}</h3>

                            {/*Conditional Edit Profile (Own Profile ) */}
                            {userIsAccountOwner && (
                                <button className={`${styles.button} ${styles.editProfileButton}`} onClick={handleClickEditProfile}>
                                    Edit Profile
                                </button>
                            ) }

                            {/* Following/Follower Counts and Conditional Follow Button (Other's Profile) */}
                            <FollowStats userIsAccountOwner={userIsAccountOwner} accountOwner={accountOwner} setAccountOwner={setAccountOwner} />
                            
                        </div>

                        {/* Creator's Profile Stats />*/}
                        <div className={styles.profileStats}>
                            <ProfileStats creatorId={accountOwner._id} />
                        </div>

                    </div>
                    {accountOwner.bio && (
                        <div className={styles.bioContainer}>
                            <p className={styles.bioText} dangerouslySetInnerHTML={{ __html: transformIframes(accountOwner.bio) }}></p>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <h3 className={styles.editTitle}>Edit Profile</h3>
                    <div className={styles.profilePictureContainerEditable} onClick={handleImageClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleImageClick()}>
                        <img
                            className={styles.profilePictureImage}
                            src={profilePicture ? profilePicture : ProfileIcon}
                            alt="Profile"
                        />
                        <div className={styles.profilePictureOverlay}>
                            <span>Change Photo</span>
                        </div>
                    </div>
    
                    <input id="fileInput" type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFileSelect} onClick={(e) => { e.target.value = null; }} />
    
                    <div className={styles.usernameDisplayStatic}>
                        <span className={styles.usernameLabel}>Username</span>
                        <p className={styles.usernameValue}>{accountOwner.username}</p>
                    </div>
    
                    <div className={styles.editorContainer}>
                        <label htmlFor="bioEditor" className={styles.editorLabel}>Bio</label>
                        <TextEditor
                            id="bioEditor"
                            initialData={bio}
                            onChange={handleTextEditorChange}
                        />
                    </div>
                    <div className={styles.actionsContainer}>
                        <button className={`${styles.button} ${styles.cancelButton}`} onClick={handleClickCancel}>
                            Cancel
                        </button>
                        <button className={`${styles.button} ${styles.saveButton}`} onClick={handleClickSaveChanges}>
                            Save Changes
                        </button>
                    </div>
                </>
            )}
            {cropImageSrc && (
                <ImageCropModal
                    imageSrc={cropImageSrc}
                    onCropComplete={(croppedFile) => {
                        setSelectedFile(croppedFile);
                        setProfilePicture(URL.createObjectURL(croppedFile));
                        URL.revokeObjectURL(cropImageSrc);
                        setCropImageSrc(null);
                    }}
                    onCancel={() => {
                        URL.revokeObjectURL(cropImageSrc);
                        setCropImageSrc(null);
                    }}
                />
            )}
            {/* Scenarios that have been pinned (section renders its own heading/empty states) */}
            <PinScenarioView creatorId={accountOwner._id} />
        </div>
    );
};

export default AccountProfile;
